import { useState } from 'react';
import {
  DEFAULT_MANAGER_OWNER_USERNAME,
  LEASING_TEAM_PUBLIC_ID,
} from './constants';
import { getValidationErrors } from './utils';

export const useTransferProperty = ({ transferProperty }) => {
  const [transferDetails, setTransferDetails] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const validate = () => {
    const errors = getValidationErrors(transferDetails);
    if (errors) {
      setValidationErrors(errors);
    }

    return !errors;
  };

  const handleTransferOnClick = () => {
    const isValid = validate();

    if (isValid) {
      transferProperty(
        transferDetails[LEASING_TEAM_PUBLIC_ID],
        transferDetails[DEFAULT_MANAGER_OWNER_USERNAME],
      );
    }
  };

  const hasValidationError = Object.values(validationErrors).some(Boolean);
  const hasValue = Object.values(transferDetails).some(Boolean);

  const isTransferButtonDisabled = hasValidationError || !hasValue;

  const updateTransferDetails = (updatedValues) => {
    setTransferDetails((prev) => ({ ...prev, ...updatedValues }));
  };

  const updateValidationErrors = (updatedValues) => {
    setValidationErrors((prev) => ({ ...prev, ...updatedValues }));
  };

  return {
    handleTransferOnClick,
    isTransferButtonDisabled,
    transferDetails,
    updateTransferDetails,
    updateValidationErrors,
    validationErrors,
  };
};
